import {
  IAddProductInput,
  ICategory,
  IProduct,
  ISeller,
  ProductStatus,
} from "muminsmart-utils";
import {
  getCategoryAttributeById,
  getSelectedCategories,
  getSelectedSubCategories,
  getSelectedSubSubCategories,
} from "./categoryVariantUtils";

interface BuildProductPreviewOptions {
  values: IAddProductInput;
  categories: ICategory[];
  selectedProduct: IProduct | null;
  seller?: ISeller;
  fallbackSeller?: ISeller;
}

export function buildProductPreviewFromFormValues({
  values,
  categories,
  selectedProduct,
  seller,
  fallbackSeller,
}: BuildProductPreviewOptions): IProduct {
  const selectedSubSubCategories = getSelectedSubSubCategories(
    categories,
    values.subSubCategoryIds ?? [],
  );
  const attributeById = getCategoryAttributeById(selectedSubSubCategories);

  return {
    id: selectedProduct?.id ?? crypto.randomUUID(),
    name: values.name,
    description: values.description,
    isMuminsChoice: selectedProduct?.isMuminsChoice ?? false,
    hsn: selectedProduct?.hsn ?? values.hsn ?? "",
    gstRate: selectedProduct?.gstRate ?? values.gstRate ?? 0,
    ean: selectedProduct?.ean ?? values.ean ?? "",
    categories: getSelectedCategories(categories, values.categoryIds ?? []),
    subCategories: getSelectedSubCategories(
      categories,
      values.subCategoryIds ?? [],
    ),
    subSubCategories: selectedSubSubCategories,
    location: selectedProduct?.location ?? values.location ?? "",
    orderCount: selectedProduct?.orderCount ?? 0,
    variants: values.variants.map((variant, index) => ({
      id: `${selectedProduct?.id ?? "preview"}-variant-${index}`,
      variantAttributes: variant.variantAttributes.map((attr) => ({
        attributeId: attr.attributeId,
        value: attr.value,
        attribute: attributeById.get(attr.attributeId),
      })),
      reservedStock: 0,
      bulkPrices: variant.bulkPrices,
      price: Number(variant.price),
      discountedPrice: Number(variant.discountedPrice),
      sku: variant.sku,
      weight: Number(variant.weight),
      productId: selectedProduct?.id ?? "",
      sellerId: values.sellerId,
      stock: Number(variant.stock),
      featuredImage: variant.featuredImage as unknown as string,
      additionalImages: variant.additionalImages as unknown as string[],
      alwaysAvailable: variant.alwaysAvailable ?? false,
      isActive: variant.isActive ?? true,
      status: selectedProduct?.status ?? ProductStatus.UnderReview,
    })),
    seller: selectedProduct?.seller ?? seller ?? fallbackSeller,
    status: selectedProduct?.status ?? ProductStatus.UnderReview,
    isActive: selectedProduct?.isActive ?? true,
    createdAt: selectedProduct?.createdAt ?? new Date(),
    updatedAt: new Date(),
  };
}
